import React, { FunctionComponent, useContext } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";
import { sendLogoutRequest } from "../api";
import { withRouter, RouteComponentProps } from "react-router";
import { useTranslate, logError } from "../helpers";
import { AppStore } from "../app/store";
import { ActionType, UserLanguage, MctToastType } from "../@types";
import {
  hasLoginSession,
  initiateLogin,
  getSlsxSignoutUrl,
} from "../helpers/loginHelpers";
import { useFlags } from "launchdarkly-react-client-sdk";

interface LoginLogoutButtonProps {
  className?: string;
  loginKey?: string;
  size?: "small" | "big";
  hideIfDisabled?: boolean;
  onLogin?: () => void;
  onClick?: () => void;
  id?: string;
}

const LoginLogoutButtonProps: FunctionComponent<LoginLogoutButtonProps &
  RouteComponentProps> = ({
  className,
  history,
  loginKey,
  size,
  hideIfDisabled,
  onLogin,
  onClick,
  id,
}) => {
  const t = useTranslate();
  const { feEnableAuthentication } = useFlags();

  const { state, dispatch } = useContext(AppStore.AppContext);

  const loggedIn = hasLoginSession() && state.beneficiary;

  const logout = async (): Promise<void> => {
    try {
      await sendLogoutRequest();
    } catch (e) {
      logError("Could not log out user (LoginLogoutButton)", e);
    }

    history.push(`/?mctt=${MctToastType.LOGGED_OUT}`);

    dispatch({ type: ActionType.RESET_STATE });

    if (!state.csr) {
      const signoutUrl = getSlsxSignoutUrl();
      window.location.href = signoutUrl;
    }
  };

  const login = (): void => {
    if (onClick) {
      onClick();
    }
    initiateLogin(state.language === UserLanguage.SPANISH, "", undefined);
  };

  const loginDisplay =
    !feEnableAuthentication && !loggedIn ? (
      <p className={className}>{t("app.login_unavailable")}</p>
    ) : (
      <Button
        id={id}
        size={size}
        className={className}
        onClick={loggedIn ? logout : onLogin || login}
      >
        {loggedIn ? t("app.menu.logout") : t(loginKey || "app.menu.login")}
      </Button>
    );

  return !feEnableAuthentication && !loggedIn && hideIfDisabled ? (
    <></>
  ) : (
    loginDisplay
  );
};

export default withRouter(LoginLogoutButtonProps);
